

















































































































































































import axios from 'axios';
import mixins from 'vue-typed-mixins';
import { LanguageObject, languageobj } from '@/i18n';
import cloneDeep from 'lodash.clonedeep';
import SurveyUtils, {
  SurveyParticipation,
  SurveyState,
  Survey,
} from '@/utils/SurveyUtils';

interface ParamsField<T> {
  state: boolean;
  value?: T;
}

export default mixins().extend({
  props: {
    survey: {
      type: Object as () => Survey,
    },
    items: {
      type: Array as () => any,
    },
    headers: {
      type: Array as () => any,
    },
  },

  computed: {
    submissionstatesOptions(): any {
      return this.submissionstates?.map((state) => ({
        text: `${this.$translate(state.name)} (${state.category})`,
        value: state,
      }));
    },
  },

  data(): {
    visible: boolean;
    step: number;
    selected: SurveyParticipation[];
    params: {
      submissionstate: ParamsField<SurveyParticipation['submissionstate']>;
      participationduedate: ParamsField<
        SurveyParticipation['participationduedate']
      >;
    };
    submissionstates?: SurveyState[];
  } {
    return {
      visible: false,
      step: 1,
      selected: [],
      params: {
        submissionstate: {
          state: false,
          value: undefined,
        },
        participationduedate: {
          state: false,
          value: undefined,
        },
      },
      submissionstates: undefined,
    };
  },

  async mounted() {
    try {
      this.submissionstates = await SurveyUtils.api.surveyState.list({
        surveyid: this.survey.id as number,
      });
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  watch: {
    async visible() {
      this.step = 1;
      this.selected = [];
      this.params = {
        submissionstate: {
          state: false,
          value: undefined,
        },
        participationduedate: {
          state: false,
          value: undefined,
        },
      };

      if (this.visible) {
        //
      } else if (!this.visible) {
        //
      }
    },
  },

  methods: {
    async save() {
      const params: any = {
        ids: this.selected.map((item) => item.id),
      };

      if (this.params.submissionstate.state) {
        params.submissionstate = this.params.submissionstate.value || null;
      }

      if (this.params.participationduedate.state) {
        params.participationduedate =
          this.params.participationduedate.value || null;
      }

      try {
        (this.$refs.alert as any).hide('bulkUpdate');
        await SurveyUtils.api.surveyParticipation.bulkUpdate(params);
        this.visible = false;
        this.$emit('reload');
        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.default', {
            values: [
              this.$languageobj('model.surveyParticipation.label', {
                choice: 2,
              }),
            ],
          }),
        });
      } catch (error) {
        (this.$refs.alert as any).show('bulkUpdate', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
